export class StorageManager {
    static setJSONToLocalStorage(key: string, value: any): void {
        const text: string = JSON.stringify(value);
        localStorage.setItem(key, text);
    }

    static getFromLocalStorage(key: string) {
        const value: string | null | undefined = localStorage.getItem(key);
        if (!value || value === 'undefined') return null;
        return JSON.parse(value);
    }

    static setProperty(key: string, value: string | number | boolean) {
        localStorage.setItem(key, JSON.stringify(value));
    }

    static deleteItem(key: string) {
        localStorage.removeItem(key);
    }

    static clearSession() {
        localStorage.removeItem('auth.token');
    }

    static getName() {
        if (localStorage.getItem('user')) {
            const user_info = StorageManager.getFromLocalStorage('user');
            return user_info.name;
        }
    }
}
